export const url = {
  // notice:
  //   process.env.NODE_ENV === "development"
  //     ? "https://service-stage.nateon.nate.com/bbs/v1/notice"
  //     : `${window.location.host}/bbs/v1/notice`,

  notice:
    process.env.NODE_ENV === "development"
      ? `http://service-dev.nateon.nate.com/bbs/v1/notice`
      : `/bbs/v1/notice`,
};
